import CommonConstants from '../constants/CommonConstants';
// import Immutable from 'immutable';

const initialState = {
	reportData: {},
	error: null
};

function ReportReducer(state = initialState, action) {
	switch (action.type) {
		case CommonConstants.GET_REPORT_DATA_SUCCESS:
			return Object.assign({}, state, {
				reportData: action.response,
				error: null
			});
			
		case CommonConstants.GET_REPORT_DATA_ERROR:
			return Object.assign({}, state, {
				reportData: {},
				error: action.error
			}); 

		default:
			return state;
	}
}

export default ReportReducer;



// WEBPACK FOOTER //
// ./reducers/ReportReducer.js